import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';
import { ISpaceTypesList } from '../../../Pages/SpaceTypes/ISpaceTypes';

export const SpaceTypesSlicer = createSlice({
  name: 'SpaceTypes',
  initialState: {
    data: {},
    isLoading: false,
  } as IReduxState<ISpaceTypesList[]>,
  reducers: {
    getSpaceTypes: (state, action) => {
      state.isLoading = true;
    },
    successGetSpaceTypes: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureGetSpaceTypes: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { getSpaceTypes, failureGetSpaceTypes, successGetSpaceTypes } =
  SpaceTypesSlicer.actions;

export default SpaceTypesSlicer.reducer;
